import { useEffect, useRef, useState } from 'react'
import { Input, Modal, Form, Select, Button, Checkbox, Image } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { debounce, trim } from 'lodash'
import { Request2 } from 'src/common/Request2'
import api from 'src/common/api'
import { showMessageError, getImageUrl } from 'src/helpers/functions'
import { log } from 'console'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

const Create = observer((props: any) => {
   const { t } = useTranslation()

   const fileInputRef = useRef<HTMLInputElement>(null)
   const CommonConfigStore = useStore('CommonConfigStore')
   const { visible, onOk, onCancel, item } = props
   console.log('item: ', item)
   const [form] = Form.useForm()
   const [img, setImg] = useState<string>('')
   const [status, setStatus] = useState(item?.markRead)
   // useEffect(() => { }, [])

   const onChangeStatus = async (e: any) => {
      console.log('val; ', e.target.checked)
      setStatus(e.target.checked)

      const result = await CommonConfigStore.updateHighlightNotification(e.target.checked, item?.id)
      if (result) {
         // showMessageError('Cập nhật thành công')
         onOk()
      } else {
         showMessageError('Cập nhật thất bại')
      }
   }

   const onFinish = async (values: any) => {
      // console.log('Received values of form: ', values)
      const result = await CommonConfigStore.createNotification(
         // trim(values?.title) || '',
         trim(values?.content) || '',
         values?.type || '0',
         img || ''
      )

      if (result) {
         form.setFieldsValue({
            content: '',
            type: 0
         })
         onOk()
      }
   }

   const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files ? event.target.files[0] : null
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']

      if (file && allowedTypes.includes(file.type)) {
         try {
            // setIsLoading(true)
            const { data } = await Request2.uploadFile(file, api.upload.uploadFile)
            console.log('Upload file response:', data)
            if (data?.filename) {
               setImg(data?.filename)
               // form.setFieldsValue({
               //    image: data?.filename
               // })
            }
         } catch (error) {
            showMessageError(error)
         } finally {
            // setIsLoading(false)
         }
      } else {
         showMessageError(t(GLOBAL_CLIENT.validateanh))
      }
      // if (fileInputRef.current) {
      //    fileInputRef.current.value = ''
      // }
   }

   const renderContent = () => {
      return (
         <Form
            {...formItemLayout}
            form={form}
            name="create"
            onFinish={debounce(onFinish, 400)}
            scrollToFirstError
         // style={{ pointerEvents: item?.id ? 'none' : 'all' }}
         >
            {/* <Form.Item
               name="title"
               label={'Tiêu đề'}
               rules={[
                  {
                     required: true,
                     message: 'Vui lòng nhập tiêu đề'
                  }
               ]}
            >
               <Input maxLength={20} />
            </Form.Item> */}
            <Form.Item
               name="content"
               initialValue={item?.description}
               label={'Nội dung'}
               rules={[
                  {
                     required: true,
                     message: 'Vui lòng nhập nội dung'
                  }
               ]}
            >
               <Input.TextArea

                  disabled={item?.id ? true : false}
                  size="large"
                  // placeholder={t('enter')}
                  autoSize={{ minRows: 5, maxRows: 200 }}
               />
            </Form.Item>
            <Form.Item name="type" label={'Người nhận'}>
               <Select size="large" defaultValue={'0'}
                  disabled={item?.id ? true : false}>
                  <Select.Option value={'0'}>{'Tất cả'}</Select.Option>
                  <Select.Option value={'1'}>{'Creator'}</Select.Option>
                  <Select.Option value={'2'}>{'Designer'}</Select.Option>
               </Select>
            </Form.Item>
            <Form.Item name="image" label={'Ảnh'}>
               <input
                  disabled={item?.id ? true : false}
                  ref={fileInputRef}
                  type="file"
                  id="image"
                  name="image"
                  accept="image/png, image/jpeg"
                  onChange={handleImageUpload}
               />
               {item?.id && (
                  <Image
                     preview={false}
                     src={getImageUrl(item?.image)}
                     alt="No data"
                     style={{
                        margin: '10px 0',
                        width: '100%',
                        maxHeight: 200,
                        objectFit: 'contain'
                     }}
                  />
               )}
            </Form.Item>
            {/* {item?.id && (
               <Form.Item
                  name="enable"
                  label={'Active thông báo'}
                  valuePropName="checked"
                  initialValue={!status}
               >
                  <Checkbox defaultChecked={!status} onChange={onChangeStatus}>
                     {'Active'}
                  </Checkbox>
               </Form.Item>
            )} */}
         </Form>
      )
   }

   return !item?.id ? (
      <Modal
         width={'68%'}
         visible={visible}
         centered
         title={'Thêm mới thông báo'}
         okText={t(GLOBAL_CLIENT.create)}
         cancelText={t(GLOBAL_CLIENT.huy)}
         onCancel={onCancel}
         onOk={form.submit}
      >
         {renderContent()}
      </Modal>
   ) : (
      <Modal
         width={'68%'}
         visible={visible}
         centered
         title={'Chi tiết thông báo'}
         okText={t(GLOBAL_CLIENT.edit)}
         cancelText={t(GLOBAL_CLIENT.huy)}
         onCancel={onCancel}
         onOk={form.submit}
         footer={[
            <>
               <Button key="back" onClick={onCancel}>
                  Đóng
               </Button>
            </>
         ]}
      >
         {renderContent()}
      </Modal>
   )
})

export default Create
